import { useState } from "react";

import { ChevronDown } from "components/icons/generated";
import Button from "ds/components/Button";
import DropdownMenu from "ds/components/DropdownMenu";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";

import { DropdownOptions } from "./types";

type ModuleVersionSecondaryLayoutDropdownProps = {
  label: string;
  options: DropdownOptions;
};

const ModuleVersionSecondaryLayoutDropdown = ({
  label: dropdownLabel,
  options: dropdownOptions,
}: ModuleVersionSecondaryLayoutDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <DropdownMenu
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      triggerComponent={
        <Button variant="secondary" active={isOpen} endIcon={ChevronDown}>
          {dropdownLabel}
        </Button>
      }
    >
      {dropdownOptions.map((option) => (
        <DropdownMenuItem
          key={option.to}
          href={option.to}
          active={option.isActive}
          onAction={() => setIsOpen(false)}
        >
          {option.label}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};

export default ModuleVersionSecondaryLayoutDropdown;
